const USER_ROLES = {
  GOD: 'admin',
  INTERNAL_ADMIN: 'internal_account_administrator',
  FINANCE_ADMIN: 'finance-admin',
  ACCOUNT_ADMIN: 'account-admin',
  ADMIN: 'Admin',
  FINANCE: 'finance',
  SHIPPER: 'Shipper',
  CARRIER: 'Carrier',
  LOCATIONS_ADMIN: 'locations_admin',
  LOCATIONS_MANAGER: 'locations_manager',
  MESSAGE_ONLY_USER: 'message-only-user',
  MESSAGE_ADMIN: 'message-admin',
  MESSAGE_MANAGER: 'message-manager',
  SHIPPER_LANE_PRICING_MANAGER: 'shipper-lane-pricing-manager',
  CARRIER_LANE_PRICING_MANAGER: 'carrier-lane-pricing-manager',
  CARRIER_BULK_AUDITOR: 'carrier-bulk-auditor',
  BULK_PRICING_MANAGER: 'bulk-pricing-manager',
  MESSAGE_USER: 'message-user',
  GROUP_MESSAGE_USER: 'message-group-user',
  FILTER_CREATOR: 'filter-creator',
  TRIP_PLANNER_ADMIN: 'trip-planner-admin',
  MASTER_ACCOUNT_USER: 'master-account-user',
  ORDER_TEMPLATE_ADMIN: 'order-template-admin',
  SUPPORT: 'support',
  ACI_ZONES_ADMIN: 'aci-zones-admin',
  MULTI_STOP_BOOKING: 'multi-stop-booking',
  DRAYAGE_QUOTES_ONLY: 'drayage_maersk_quotes',
  CUSTOMER_MANAGER: 'customer_manager',
  SHIPPER_ONBOARDING: 'shipper-onboarding',
  UV_REPORT_MANAGER: 'uv-report-manager',
  REFERENCE_NUMBERS_ADMIN: 'reference-numbers-admin',
  ACCESSORIALS_ADMIN: 'accessorials-admin',
  BILLING_MANAGER_ADMIN: 'billing-manager-admin',
  BILLING_STATUS_ADMIN: 'billing_status_admin',
  BILLING_STATUS_MANAGER: 'billing_status_manager',
  BILLING_STATUS_USER: 'billing_status_user',
  BRIDGE_CODE_MANAGER: 'bridge_code_manager',
};

export default USER_ROLES;
